import { render } from "./PlanetDatabase.vue?vue&type=template&id=d66a8ebc"
import script from "./PlanetDatabase.vue?vue&type=script&lang=js"
export * from "./PlanetDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__